import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80c863ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "user-edit-model",
  ref: "userEditModel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("请按照模板格式进行导入，点击")

import {
  reactive, withDefaults, ref, watch,
} from 'vue';
import moment from 'moment';
import { serverIp, } from '@/configs/index';
import {
  Modal, Button, Upload, Empty, message,
} from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';

interface Props {
  importVisible?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    importVisible: { type: Boolean, default: false }
  },
  emits: ['confirm', 'cancal',],
  setup(__props: any, { emit: emits }) {

const props = __props as { importVisible: boolean }

const { Dragger, } = Upload;



/**
 * 下载模板
 * @method downloadImportTemplate
 * @returns {void}
 */
const downloadImportTemplate = (): void => {
  window.open(`${serverIp}/user/downloadTemplate`);
};



const handleConfirm = (): void => {
  emits('confirm');
};

const handleCancle = (): void => {
  emits('cancal');
};

/**
 * 上传文件结果回调
 * @method handleChange
 * @param {any} file 上传的结果
 * @returns {void}
 */
const handleChange = (file: any): void => {
  if (file.status === 'done') {
    message.success('导入成功');
    setTimeout(() => {
      handleConfirm();
    }, 1000);
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      getContainer: () => _ctx.$refs.userEditModel,
      title: "批量导入",
      width: '4.8rem',
      footer: false,
      visible: props.importVisible,
      onCancel: handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Dragger), {
            accept: ".xls,.xlsx",
            action: `${_unref(serverIp)}/user/uploadExcel`,
            onChange: _cache[0] || (_cache[0] = ({file}) => handleChange(file))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Empty), { description: "点击或拖拽文件到此处上传" })
            ]),
            _: 1
          }, 8, ["action"])
        ]),
        _createElementVNode("div", { class: "operation" }, [
          _createElementVNode("div", { class: "tip" }, [
            _hoisted_4,
            _createElementVNode("span", { onClick: downloadImportTemplate }, "下载模板")
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: handleConfirm
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "width", "visible"])
  ], 512))
}
}

})